import Select from "@common/components/Select";
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import {
  MeetingPurpose,
  MeetingPurposeLabels,
  MeetingServiceType,
  MeetingSource,
} from "@services/meetings/types";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ElogMeetingContext } from "../context";
import Typography from "@common/components/Typography";

const MeetingOptions = () => {
  const { t } = useTranslation();
  const { form, mcus, dispatchElogMeetingDetails } =
    useContext(ElogMeetingContext);

  const isNotCertifiable = () => {
    return (
      form.details?.purpose != MeetingPurpose.CertificationOfManaged &&
      form.details?.purpose != MeetingPurpose.CertificationOfUnmanaged
    );
  };
  return (
    <Grid
      container
      direction="column"
      sx={{ width: '100%', gap: "1rem",
        padding: "1rem", }}
    >
      {form.elogMeeting === undefined ? (
        <CircularProgress sx={{ position: "relative", left: "50%" }} />
      ) : (
        <>
          <Select
            label={t("Meeting Service")}
            value={
              form.details?.meetingServiceType ?? MeetingServiceType.Concierge
            }
            onChange={(event) =>
              dispatchElogMeetingDetails({
                meetingServiceType: event.target.value as MeetingServiceType,
              })
            }
          >
            {[
              MeetingServiceType.Concierge,
              MeetingServiceType.Self,
              MeetingServiceType.Unknown,
            ].map((source) => (
              <MenuItem key={source} value={source}>
                {t(source)}
              </MenuItem>
            ))}
          </Select>
          <Select
            label={t("Purpose")}
            value={form.details?.purpose ?? MeetingPurpose.RegularMeeting}
            onChange={(event) =>
              dispatchElogMeetingDetails({
                purpose: event.target.value as MeetingPurpose,
              })
            }
          >
            {Object.values(MeetingPurpose).map((source) => (
              <MenuItem key={source} value={source}>
                {t(MeetingPurposeLabels[source])}
              </MenuItem>
            ))}
          </Select>
          <Select
            label={t("Source")}
            value={form.details?.source ?? MeetingSource.Symphony}
            onChange={(event) =>
              dispatchElogMeetingDetails({
                source: event.target.value as MeetingSource,
              })
            }
          >
            {Object.values(MeetingSource).map((source) => (
              <MenuItem key={source} value={source}>
                {t(source)}
              </MenuItem>
            ))}
          </Select>
          <FormControl fullWidth size="small">
            <TextField
              label={t("Owner")}
              value={form.details?.meetingOwner}
              fullWidth
              disabled={true}
            />
          </FormControl>
          {isNotCertifiable() && (
            <>
              <FormControl fullWidth size="small">
                <TextField
                  label={t("Requester")}
                  value={form.details?.meetingRequester}
                  fullWidth
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    dispatchElogMeetingDetails({
                      meetingRequester: e.target.value,
                    })
                  }
                />
              </FormControl>
              <FormControl fullWidth size="small">
                <TextField
                  label={t("Creator")}
                  value={
                    form.details?.meetingCreator &&
                    `${form.details?.meetingCreator.firstName} ${form.details?.meetingCreator.lastName}`
                  }
                  fullWidth
                  disabled={true}
                />
              </FormControl>
            </>
          )}
          <Select
            label={t("Video Bridge (MCU)")}
            value={form.details?.mcu?.id ?? ""}
            onChange={(event) => {
              let mcu = mcus.find((mcu) => mcu.id == event.target.value);
              dispatchElogMeetingDetails({
                mcu: mcu,
              });
            }}
            disabled={mcus.length === 0}
          >
            {mcus.map((mcu) => (
              <MenuItem key={mcu.id} value={mcu.id}>
                {`${mcu.name} (${mcu.ipAddress})`}
              </MenuItem>
            ))}
          </Select>
          {isNotCertifiable() && (
            <Grid container direction="row" sx={{ width: '100%' }}>
              <FormControlLabel
                sx={{ marginRight: "3rem" }}
                control={
                  <Checkbox
                    checked={form.details?.recorded ?? false}
                    onChange={(_, checked) =>
                      dispatchElogMeetingDetails({ recorded: checked })
                    }
                  />
                }
                label={
                  <Typography size="small">
                    {t("Meeting was recorded")}
                  </Typography>
                }
                key="elogRecorded"
              />
              <FormControlLabel
                sx={{ marginRight: "3rem" }}
                control={
                  <Checkbox
                    checked={form.details?.overtime ?? false}
                    onChange={(_, checked) =>
                      dispatchElogMeetingDetails({ overtime: checked })
                    }
                  />
                }
                label={
                  <Typography size="small">
                    {t("Meeting went overtime")}
                  </Typography>
                }
                key="elogOvertime"
              />
              <FormControlLabel
                sx={{ marginRight: "3rem" }}
                control={
                  <Checkbox
                    checked={form.details?.vipMeeting ?? false}
                    onChange={(_, checked) =>
                      dispatchElogMeetingDetails({ vipMeeting: checked })
                    }
                  />
                }
                label={<Typography size="small">{t("Meeting VIP")}</Typography>}
                key="elogVIP"
              />
            </Grid>
          )}
        </>
      )}
    </Grid>
  );
};

export default MeetingOptions;
